import React from 'react';

import { PDFViewer } from 'components';
import policyPdf from 'assets/personal-data.pdf';
import dataProcessingConsentPdf from 'assets/data-processing-consent.pdf';
import offerPdf from 'assets/offer.pdf';

const Docs = ({ match }) => {
  const pdfMap = {
    policy: policyPdf,
    dpc: dataProcessingConsentPdf,
    offer: offerPdf,
  };
  const file = pdfMap[match.params.docName] ?? null;

  return file ? <PDFViewer file={file} /> : null;
};

export default Docs;
